
import { Component, Vue } from 'vue-property-decorator'
import close from '@/assets/icons/close.svg'

@Component({
  name: 'NewsletterForm',
  components: { close },
})
export default class NewsletterForm extends Vue { }
